import { render, staticRenderFns } from "./detail_service_request.vue?vue&type=template&id=e13596ee&"
import script from "./detail_service_request.vue?vue&type=script&lang=js&"
export * from "./detail_service_request.vue?vue&type=script&lang=js&"
import style0 from "./detail_service_request.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports